export interface CampaignButtonInputApiModel {
    label: string;
    url: string;
    foreground: string;
    background: string;
    is_selected: boolean;
}
